
const ProjectsOverview = () => {
  return (
    <section className="py-16 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-4xl font-bold text-gray-900 mb-6">
            Golden Black Chemical Supply Projects
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Delivering comprehensive chemical solutions across the entire oil and gas value chain 
            with specialized expertise in UAE operations and ADNOC partnerships.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          <div className="bg-white rounded-lg shadow-lg p-6">
            <div className="w-16 h-16 bg-teal-100 rounded-lg flex items-center justify-center mb-4">
              <i className="ri-oil-line text-teal-600 text-2xl"></i>
            </div>
            <h3 className="text-xl font-bold text-gray-900 mb-3">Upstream Operations</h3>
            <p className="text-gray-600 mb-4">
              Complete chemical solutions for drilling, completion, and production operations 
              including specialized formulations for challenging reservoir conditions.
            </p>
            <ul className="text-sm text-gray-600 space-y-1">
              <li>• Drilling fluid systems</li>
              <li>• Completion chemicals</li>
              <li>• Production enhancement</li>
              <li>• Well stimulation</li>
            </ul>
          </div>

          <div className="bg-white rounded-lg shadow-lg p-6">
            <div className="w-16 h-16 bg-blue-100 rounded-lg flex items-center justify-center mb-4">
              <i className="ri-shield-check-line text-blue-600 text-2xl"></i>
            </div>
            <h3 className="text-xl font-bold text-gray-900 mb-3">Production Protection</h3>
            <p className="text-gray-600 mb-4">
              Advanced chemical solutions to mitigate corrosion, erosion, and scale formation 
              while optimizing production efficiency and equipment longevity.
            </p>
            <ul className="text-sm text-gray-600 space-y-1">
              <li>• Corrosion inhibitors</li>
              <li>• Scale inhibition systems</li>
              <li>• Erosion control solutions</li>
              <li>• Asset integrity programs</li>
            </ul>
          </div>

          <div className="bg-white rounded-lg shadow-lg p-6">
            <div className="w-16 h-16 bg-green-100 rounded-lg flex items-center justify-center mb-4">
              <i className="ri-settings-3-line text-green-600 text-2xl"></i>
            </div>
            <h3 className="text-xl font-bold text-gray-900 mb-3">Specialized Services</h3>
            <p className="text-gray-600 mb-4">
              Comprehensive technical services including scale analysis, pumping services, 
              and custom chemical formulations for specific operational requirements.
            </p>
            <ul className="text-sm text-gray-600 space-y-1">
              <li>• Scale analysis & monitoring</li>
              <li>• Chemical pumping services</li>
              <li>• Custom formulations</li>
              <li>• Technical consulting</li>
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ProjectsOverview;
